module.exports = __webpack_public_path__ + "img/logo2.639e5f98.png";